export default {
  getStatus (state) {
    return state.status
  },
  isPartner (state) {
    return state.isPartner
  },
  partnerStatus (state) {
    return state.partnerStatus
  },
  identIsPartner (state) {
    return state.identIsPartner
  },
  identStatus (state) {
    return state.identStatus
  },
  identPartnerStatus (state) {
    return state.identPartnerStatus
  }
}
